var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card__content" },
      [
        _c("p", [
          _c("label", { staticClass: "big-label" }, [
            _c("strong", [_vm._v(_vm._s(_vm.$t("message.contenedor")) + ": ")]),
            _c("a", { attrs: { target: "_blank", href: _vm.path } }, [
              _vm._v(_vm._s(_vm.contenedor.number))
            ])
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "big-label" }, [
            _c("strong", [_vm._v(_vm._s(_vm.$t("message.patio")) + ":")]),
            _vm._v(
              " " +
                _vm._s(
                  _vm.contenedor.yard !== null ? _vm.contenedor.yard.name : ""
                )
            )
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "big-label" }, [
            _c("strong", [_vm._v(_vm._s(_vm.$t("message.cliente")) + ":")]),
            _vm._v(
              " " +
                _vm._s(
                  _vm.contenedor.customer !== null &&
                    _vm.contenedor.customer !== undefined
                    ? _vm.contenedor.customer.name
                    : ""
                ) +
                " [" +
                _vm._s(_vm.contenedor.customer_code) +
                "]"
            )
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "big-label" }, [
            _c("strong", [_vm._v("Gate IN:")]),
            _vm._v(" " + _vm._s(_vm.contenedor.gate_in_date))
          ])
        ]),
        _vm._v(" "),
        _c("table-bar", {
          attrs: {
            rows: [
              _vm.contenedor.garita_finalizada === "S",
              ((_vm.contenedor.is_caja === "S" &&
                _vm.contenedor.inspection_b === "S") ||
                _vm.contenedor.is_caja !== "S") &&
                ((_vm.contenedor.is_maquina === "S" &&
                  _vm.contenedor.inspection_m === "S") ||
                  _vm.contenedor.is_maquina !== "S") &&
                !(
                  _vm.contenedor.is_caja === "N" &&
                  _vm.contenedor.is_maquina === "N"
                ),
              ((_vm.contenedor.is_caja === "S" &&
                _vm.contenedor.estimado_b === "S") ||
                _vm.contenedor.is_caja !== "S") &&
                ((_vm.contenedor.is_maquina === "S" &&
                  _vm.contenedor.estimado_m === "S") ||
                  _vm.contenedor.is_maquina !== "S") &&
                !(
                  _vm.contenedor.is_caja === "N" &&
                  _vm.contenedor.is_maquina === "N"
                ),
              _vm.contenedor.is_caja === "S" &&
                _vm.contenedor.aprobado_b === "S" &&
                (_vm.contenedor.is_maquina === "N" ||
                  (_vm.contenedor.is_maquina === "S" &&
                    _vm.contenedor.aprobado_m === "S")),
              ((_vm.contenedor.is_caja === "S" &&
                _vm.contenedor.repaired === "S") ||
                _vm.contenedor.is_caja !== "S") &&
                ((_vm.contenedor.is_maquina === "S" &&
                  _vm.contenedor.repaired_m === "S") ||
                  _vm.contenedor.is_maquina !== "S") &&
                !(
                  _vm.contenedor.is_caja === "N" &&
                  _vm.contenedor.is_maquina === "N"
                ),
              _vm.contenedor.kim_salida === "S" || _vm.contenedor.status === "T"
            ]
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf874e0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf874e0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ItemDashboard.vue
// module id = 281
// module chunks = 0